import { z } from '@betty/toolkit/api';
import { ScreenNameErrorCode, ScreenNameErrorMap } from './ScreenName.type';

export const screenNameErrorMap: ScreenNameErrorMap = {
  [ScreenNameErrorCode.Duplicate]: 'screenNameDuplicateError',
  [ScreenNameErrorCode.ProfanityFilter]: 'screenNameProfanityError',
};

const alphanumericUnderscoresHyphensRegex = /^[a-zA-Z0-9_-]+$/;
const lengthErrorMsg = 'screenNameLengthError';
export type ScreenNameData = z.infer<typeof ScreenNameSchema>;

export const ScreenNameSchema = z
  .string()
  .min(3, { message: lengthErrorMsg })
  .max(20, { message: lengthErrorMsg })
  .regex(alphanumericUnderscoresHyphensRegex, {
    message: 'screenNameInvalidCharactersError',
  });
